import React from "react";
// { useState } 
import PropTypes from "prop-types";
import { Route, Redirect, useHistory } from "react-router-dom";
import { CanCan } from "@hedgefund/shared";
import jwtDecode from "jwt-decode";

const ProtectdRoute = ({ Component, path, permissionName }) => {
  const history = useHistory();
  const token = localStorage.getItem("token");

  var newUrl = "";
  if (token) {
    const decodeToken = jwtDecode(token);

    const currentDate = new Date();
    const DecodeDateTime = new Date(decodeToken.exp * 1000)
    if (DecodeDateTime < currentDate) {
      localStorage.removeItem("token");
      newUrl = `/login?callback=${history.location.pathname.replace("/", "") + history.location.search}`;
    }
  } else {
    newUrl = `/login?callback=${history.location.pathname.replace("/", "") + history.location.search}`;
  }
  const url = newUrl !== "" ? newUrl : "/login";
  return (
    <Route
      exact
      path={path}
      render={(props) => {
        if (sessionStorage.getItem("token") ?? localStorage.getItem("token")) {
          return permissionName ? (
            <CanCan permissionName={permissionName}>
              <Component {...props} />
            </CanCan>
          ) : (
            <Component {...props} />
          );
        } else {
          return <Redirect to={{ pathname: url }} />;
        }
      }}
    />
  );
};

ProtectdRoute.propTypes = {
  Component: PropTypes.any,
};

export default ProtectdRoute;
